export const faqIntro =
  "These answers explain what Agentic Plus does, how approvals work, and where teams should apply human review.";

export const faqs = [
  {
    id: "what-is-agentic-plus",
    question: "What is Agentic Plus?",
    answer:
      "Agentic Plus is an evidence-led creative growth platform. It organizes brand and product knowledge, market evidence, creative strategy, asset production, approvals, delivery, and learning into trackable growth missions.",
  },
  {
    id: "who-is-it-for",
    question: "Who is it for?",
    answer:
      "Agentic Plus is for brand growth teams, agencies, and media buyers who need repeatable creative production without losing brand context, version control, or human review.",
  },
  {
    id: "what-can-it-generate",
    question: "What can it generate?",
    answer:
      "The current scope includes creative briefs, campaign copy, images, and standard video. Outputs remain connected to their brief, references, model context, and version history.",
  },
  {
    id: "automatic-publishing",
    question: "Can it publish ads automatically?",
    answer:
      "Agentic Plus does not bypass controls. External advertising actions require explicit authorization, a reviewable destination, and an approval record. Planned execution flows use Dry Run, separate upload and publish permissions, state read-back, and undo where supported.",
  },
  {
    id: "approvals",
    question: "How do approvals work?",
    answer:
      "A person reviews the specific asset, cost, destination, or action before it proceeds. Approval is bound to the reviewed version or execution plan, so a later change needs a new decision.",
  },
  {
    id: "tenant-isolation",
    question: "How is tenant data isolated?",
    answer:
      "Work is organized in scoped workspaces. Brand, product, asset, task, and analysis context is filtered by workspace authorization so one client cannot browse another client's data.",
  },
  {
    id: "evidence-retention",
    question: "What happens to source evidence?",
    answer:
      "Evidence is retained with its source, time context, and relationship to the brief or recommendation. Verified facts are kept separate from model inference and creative interpretation.",
  },
  {
    id: "platform-support",
    question: "Does it support Meta and Google Ads?",
    answer:
      "Meta Ads is the first governed delivery target in the roadmap: PAUSED creation, approved ACTIVE publishing, state read-back, and undo are permission-controlled. Google Ads and additional channels follow after Meta.",
  },
  {
    id: "roadmap",
    question: "What is on the roadmap?",
    answer:
      "The roadmap adds URL-to-Mission enrichment, deeper Creative Intelligence, Experiment Memory, Decision Journal, fatigue detection, landing-page intelligence, governed Meta execution, and scoped MCP access. Planned items are not represented as launched.",
  },
];
